export default {
    common: {
        hello: '你好，{name}!',
        total: '合计:',
        programTrans:'程序跳转',
        transI18n:'切换国际化',
        confirm:'确 认',
        reset:'重置',
        submit:'提交',
        info:"信息",
        error:"错误",
        question:"问题",
        warning:"警告",
        placeholder:"请输入",
        selectholder:"请选择",
        rowNumber:"行号",
        actions:"操作",
        query:"查询",
        add:"添加",
        delete:"删除",
        edit:"编辑",
        save:"保存",
        cancle:"取消",
        import:'导入',
        export:'导出',
        detail:'详情',
        close:'关闭',
        createUser: '创建人',
        createTime: '创建时间',
        updateUser: '最后一次修改人',
        updateTime: '最后一次修改时间',
        remark: '备注',
        required: '为必输项'
    },
    global:{
        setParam:'设置全局参数',
        getParam:'获取全局参数'
    }
}